export const COMMON_HEADER_ID = 'common-header';
export const CLIENT_AUTOTASK_SUBHEADER_ID = 'client-autotask-subheader';
